<div class="d-flex justify-content-end my-4">
  @if(!podeEditar){
    <button disabled type="text" title="Sem permissão" class="btn btn-light waves-effect">
      <i class="bx bx-block btn-sm font-size-16 align-middle me-2"></i>Adicionar
    </button>
  }@else {
    <button class="btn btn-primary w-md" (click)="openNewmessageModal()">
      Adicionar
    </button>
  }
</div>

<div class="row mb-md-2">
  <div class="table-responsive">
    <table
      class="table align-middle datatable dt-responsive table-check nowrap datatables table-striped table-bordered"
      style="border-collapse: collapse; border-spacing: 0 8px; width: 100%"
    >
      <thead class="bg-light">
        <tr>
          <th class="p-3">
            <span class="fw-bold mb-2">Mensagem</span>
          </th>
          <th class="p-3">
            <span class="fw-bold">Ações</span>
          </th>
        </tr>
      </thead>

      <tbody>
        @if (isLoading) {
          <tr>
            <td colspan="7" class="text-center position-relative">
              <div
                class="d-flex justify-content-center align-items-center"
                style="height: 150px"
              >
                <span
                  class="spinner-border"
                  style="width: 3rem; height: 3rem"
                  role="status"
                  aria-hidden="true"
                ></span>
              </div>
            </td>
          </tr>
        } @else {
          @for (row of customMessages; track $index) {
            <tr>
              <td>{{ row.mensagem }}</td>
              <td>
                <div class="dropdown" ngbDropdown>

                  @if(!podeEditar){
                    <i title="Sem permissão" class="bx bx-block font-size-16 align-middle"></i>
                  }@else {
                    <button
                    class="btn btn-link font-size-16 shadow-none py-0 text-muted dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    ngbDropdownToggle
                  >
                    <i class="bx bx-dots-horizontal-rounded"></i>
                  </button>
                  <ul class="dropdown-menu" ngbDropdownMenu>
                    <li>
                      <button
                        class="dropdown-item"
                        (click)="openNewmessageModal(row)"
                      >
                        Visualizar
                      </button>
                    </li>
                    <li>
                      <button
                        class="dropdown-item"
                        (click)="onDeleteCustomMessage(row)"
                      >
                        Deletar
                      </button>
                    </li>
                  </ul>
                  }
                  
                </div>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
</div>
